import { render, staticRenderFns } from "./CreatePurchase.vue?vue&type=template&id=2953363f&"
import script from "./CreatePurchase.vue?vue&type=script&lang=js&"
export * from "./CreatePurchase.vue?vue&type=script&lang=js&"
import style0 from "./CreatePurchase.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports